
import { MetaReferrer } from '../user';
import { CommissionsData, PiggyTransaction } from './piggy.models';

export const mapPiggyTransactionToCommissionsData = (piggyTransaction: Partial<PiggyTransaction>): CommissionsData => {
  return {
    amount: piggyTransaction.amount,
    ref: piggyTransaction.ref,
    date: piggyTransaction.createdAt,
    limitedBase: piggyTransaction.payload.limitedBase,
    orderPriceNoTaxAmtBase: piggyTransaction.payload.orderPriceNoTaxAmtBase,
    feeType: piggyTransaction.payload.feeType,
    description: piggyTransaction.payload.description,
    type: piggyTransaction.type,
    status: piggyTransaction.status,
    feePct: piggyTransaction.payload.feePct,
    product: piggyTransaction.payload.product,
    originalFeeDate: piggyTransaction.payload.originalFeeDate
  };
};

export function formatCommissionText(c: { assigned: number; general: number; }): string {
  if (c.assigned === 0) return '';
  return (c.assigned > c.general) ?
    `Como tú eres especial, tienes un ${c.assigned}% de comisión en vez de ${c.general}% ` :
    `Comisión del ${c.assigned}%`;
}

export function calculateProgressPercent(couponUsesCount: number): number {
  if (couponUsesCount >= 1 && couponUsesCount <= 9) {
    return 38 * (couponUsesCount / 10);
  } else if (couponUsesCount >= 10 && couponUsesCount <= 29) {
    return 38 + 25 * ((couponUsesCount - 10) / 20);
  } else if (couponUsesCount >= 30 && couponUsesCount <= 99) {
    return 68 + 25 * ((couponUsesCount - 30) / 70);
  } else if (couponUsesCount >= 100) {
    return 100;
  } else {
    return 25 * (1 / 10);
  }
}

export function formatCommissionBase(item: { limitedBase?: number; orderPriceNoTaxAmtBase: number; amount: number; feePct: number; }): number {
  if (item.limitedBase !== undefined) {
    return item.limitedBase ? item.limitedBase : item.orderPriceNoTaxAmtBase;
  } else {
    let base = item.orderPriceNoTaxAmtBase;
    const calculatedBase = item.amount / (item.feePct / 100);
    if (Math.trunc(calculatedBase) !== Math.trunc(base)) {
      base = calculatedBase;
    }
    return base;
  }
}

export function isCommissionBaseLimited(item: { limitedBase?: number; orderPriceNoTaxAmtBase: number; amount: number; feePct: number; }): boolean {
  if (item.limitedBase !== undefined) {
    return item.limitedBase !== null;
  } else {
    const base = item.orderPriceNoTaxAmtBase;
    const calculatedBase = item.amount / (item.feePct / 100);
    return Math.trunc(calculatedBase) !== Math.trunc(base);
  }
}

/**
 * Determines if the influencer can withdraw money to their bank account based on their meta referrer information and coupon amount orders.
 * In the current implementation, if the fee version is 2 and the first fee version is also 2,
 * the influencer can only withdraw to their bank account if their coupon amount orders are greater than or equal to 500€.
 * @param metaReferrer The meta referrer information of the influencer.
 * @param couponAmtOrders The total amount of coupon orders.
 * @returns A boolean indicating if the influencer can withdraw money to their bank account.
 */
export function canWithdrawToBank(metaReferrer: MetaReferrer, couponAmtOrders: number): boolean {
  if (metaReferrer?.feeVersion === 2 && metaReferrer?.firstFeeVersion === 2) {
    return couponAmtOrders >= 500;
  }
  return true;
}
